import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

/**
 * /checkout — redirect shim.
 * If a user navigates directly to /checkout (e.g. via browser back/forward or
 * a bookmarked link), go back to the previous page and open the checkout modal.
 * If there's no previous page (fresh navigation), go to /cart and open modal.
 */
const CheckoutPage = () => {
  const { openCheckout, items } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    if (items.length === 0) {
      navigate('/cart', { replace: true });
      return;
    }
    // Navigate back (or to home if no history), then open modal
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
    setTimeout(() => openCheckout(), 80);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default CheckoutPage;
